import { useToast } from "@chakra-ui/react";
import { createContext, useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const toast = useToast();
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [user, setUser] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const toastShownRef = useRef(false);

  // Keep token in localStorage
  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }, [token]);

  // Keep user in localStorage
  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  }, [user]);

  const login = useCallback((token, userData) => {
    setToken(token);
    setUser(userData);
    toastShownRef.current = false; // Reset when logging in
  }, []);

  const logout = useCallback(() => {
    if (!toastShownRef.current) {
      toast({
        title: "Session Expired",
        description: "Your session has expired. Please log in again.",
        status: "warning",
        duration: 5000,
        position: "top",
        isClosable: true,
      });
      toastShownRef.current = true;
    }
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  }, [navigate, toast]);

  return (
    <AuthContext.Provider value={{ token, user, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
